import React from "react";
import employeesData from '../../Pool/data'
import './SalarySummarizing.css'

const SalarySummarizing = (props) => {

    const summarizingSalaries = () => {
        return employeesData.PRACOWNICY.reduce((total, employee) => {
            return total + +employee.wynagrodzenieKwota
        }, 0);
    };

    const summarizingSalariesForDepartment = (department) => {
        return employeesData.PRACOWNICY.reduce((total, employee) => {
            if (employee.dzial === department) {
                return total + +employee.wynagrodzenieKwota
            } else {
                return total
            }
        }, 0)
    };

    const createNewSummarizingOfDepartment = () => {
        return props.departments.map(department => {
            return <p className='summarizing-styles'>Pracownicy Działu {department.value} łącznie zarabiają: {summarizingSalariesForDepartment(department.value)} PLN </p>
        })
    };

    return (
        <>
            <div className='summarizing-box'>
            <p className='summarizing-styles'>Pracownicy łącznie zarabiają: {summarizingSalaries()} PLN </p>

            {createNewSummarizingOfDepartment()}
            </div>
        </>
    )
};

export default SalarySummarizing